var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
class FieldCondition {
    fieldName;
    value;
    groupBy;
}
export var DropFilterState;
(function (DropFilterState) {
    DropFilterState["DROPPING"] = "DROPPING";
    DropFilterState["NOT_DROPPING"] = "NOT_DROPPING";
})(DropFilterState || (DropFilterState = {}));
export class LogsDropFilterModel {
    id;
    logType;
    fieldConditions;
    description;
    thresholdInGB;
    active;
    state = DropFilterState.NOT_DROPPING;
}
__decorate([
    Type(() => FieldCondition),
    __metadata("design:type", Array)
], LogsDropFilterModel.prototype, "fieldConditions", void 0);
//# sourceMappingURL=logs-drop-filter.js.map